import router from '../../router'
import assessmentRouter from '../../router/assessmentstate'
import {loadLocaleMessages} from "../../plugins/i18n";

export default {
  namespaced: true,
  state: {
    assessmenttoken : null,
    authToken : null,
    assessmentid: null,
    verificationUrl: null,
    maskedMobile: null,
    maskedEmail: null,
    onBreak: null,
  },
  mutations: {
    setAssessmenttoken(state,token){
      state.assessmenttoken=token;
    },
    setAuthToken(state,authToken){
      state.authToken=authToken;
    },
    setBreak(state,onBreak){
      state.onBreak=onBreak;
    },
    setAssessmentid(state,assessmentid){
      state.assessmentid=assessmentid;
    },
    setVerificationUrl(state,verificationUrl){
      state.verificationUrl=verificationUrl;
    },
    setMaskedMobile(state,maskedMobile){
      state.maskedMobile=maskedMobile;
    },
    setMaskedEmail(state,maskedEmail){
      state.maskedEmail=maskedEmail;
    }
  },
  actions: {
    validateAssessmenttoken({commit, dispatch},assessmenttoken){
      dispatch('logout',{clearAssessmenttoken:true, navigate:false});
      return this.$http.post('/auth/assessmenttoken',{assessmenttoken}).then((response)=>{
        const result=response.data.data;
        commit('setAssessmenttoken',assessmenttoken);
        commit('setAssessmentid',result.assessmentid);

        if(result.token){
          commit('setAuthToken',result.token);
          //Person not verified yet, proceed with registration
          router.replace({name:'Register'});
        }else{
          commit('setMaskedMobile',result.person.mobile);
          commit('setMaskedEmail',result.person.email);
          //Person verified, proceed with login
          router.replace({name:'LoginWithToken'});
        }
      }).catch((err)=>{
        const data = {
          title: 'errors.'+err.response.data.message+'.title',
          message: 'errors.'+err.response.data.message+'.description',
          afterText: 'general.ok',
          after:()=>{
            router.replace({ name: 'Home' });
          }
        };
        router.replace({ name: 'Error', params: data });
      });
    },
    logout({dispatch}, {clearAssessmenttoken=true, navigate=false}){
      dispatch('assessment/saveAnswerBuffer',true,{root:true}).then(()=>{
          dispatch('assessment/saveAuditLogBuffer',true,{root:true}).then(()=>{
            return dispatch('logoutRedirect',{clearAssessmenttoken, navigate})
          });
      });
    },
    logoutRedirect({dispatch,rootState,commit},{clearAssessmenttoken=true, navigate=false}){
      if(!rootState.assessment || !rootState.assessment.assessment){
        return dispatch('logoutWithoutSaving',{clearAssessmenttoken, navigate});
      }

      return this.$http.get('/assessments/'+rootState.assessment.assessment.assessmentid+'/redirect').then((response)=>{
        if(response.data.data.url){
          return dispatch('logoutWithoutSaving',{clearAssessmenttoken,navigate:false}).then(()=>{
            commit('setGlobalLoading',true, {root:true});
            document.location.href = response.data.data.url;
          });
        }else{
          return dispatch('logoutWithoutSaving',{clearAssessmenttoken, navigate})
        }
      });
    },
    logoutWithoutSaving({commit,state}, {clearAssessmenttoken=true, navigate=false}){
      if(clearAssessmenttoken){
        commit('setAssessmenttoken',null);
        commit('setMaskedMobile',null);
        commit('setMaskedEmail',null);
        commit('setAssessmentid',null);
      }
      commit('language/changeLocale','en',{root:true});
      loadLocaleMessages('en');
      commit('setBreak',false);
      commit('setAuthToken',null);
      commit('assessment/setAssessment',null, {root:true});
      commit('journey/setJourney',null, {root:true});
      commit('speedtest/clear',null, {root:true});
      if(navigate){
        if(state.assessmenttoken){
          router.replace({name:'LoginWithToken'});
        }else{
          router.replace({name:'Login'});
        }
      }
    },
    sendLoginVerificationCodeToNumber({commit},{mobilecountry, mobile, via}){
      return this.$http.post('/auth/login',{mobilecountry, mobile, via}).then((response)=>{
        const result=response.data.data;
        commit('setVerificationUrl',result.url);
        return response.data;
      }).catch((err)=>{
        throw err.response.data;
      });
    },
    sendLoginVerificationCodeToEmail({commit},{email}){
      return this.$http.post('/auth/login',{email}).then((response)=>{
        const result=response.data.data;
        commit('setVerificationUrl',result.url);
        return response.data;
      }).catch((err)=>{
        throw err.response.data;
      });
    },
    sendLoginVerificationCodeForToken({state,commit}, via){
      return this.$http.post('/auth/login/assessmenttoken',{assessmenttoken: state.assessmenttoken, via}).then((response)=>{
        const result=response.data.data;
        commit('setVerificationUrl',result.url);
        return response.data;
      }).catch((err)=>{
        throw err.response.data;
      });
    },
    validateJwt({commit,dispatch},{assessmentid,jwt}){
      commit('setAuthToken',jwt);
      commit('setBreak',false);
      commit('setAssessmentid',assessmentid);
      commit('setVerificationUrl',null);
      dispatch('speedtest/start',null,{root:true});
      dispatch('assessment/loadFullyAndBlock',assessmentid,{root:true}).then(()=>{
        assessmentRouter((route)=>{
          router.replace(route);
        });
      });
    },
    verifyOtpForLogin({state,commit,dispatch},{otp}){
      return this.$http.post(state.verificationUrl,{otp},{baseURL:null}).then((response)=>{
        const result=response.data.data;
        if(result.assessmentid){
          commit('setAuthToken',result.token);
          commit('setBreak',false);
          commit('setAssessmentid',result.assessmentid);
          commit('setVerificationUrl',null);
          dispatch('speedtest/start',null,{root:true});
          dispatch('assessment/loadFullyAndBlock',result.assessmentid,{root:true}).then(()=>{
            assessmentRouter((route)=>{
              router.replace(route);
            });
          });
        }else{
          throw new Error('no_assessments');
        }
        return response.data;
      }).catch((err)=>{
        if(!err.response){
          throw err;
        }else{
          throw err.response.data;
        }
      });
    },
    startBreak({commit}){
      commit('setBreak',true);
      commit('journey/togglePauseOn',null,{root:true});
      router.replace('/break');
    },
    sendBreakOtp(){
      return this.$http.post('person/break/send',{});
    },
    verifyBreakOtp({commit},otp){
      return this.$http.post('person/break/verify',{otp}).then((response)=>{
        if(response.data.verified){
          commit('setBreak',false);
          assessmentRouter((route)=>{
            router.replace(route);
          });
        }
      });
    },
    completeRedirect({dispatch,rootState,commit}){
      return this.$http.get('/assessments/'+rootState.assessment.assessment.assessmentid+'/redirect').then((response)=>{
        if(response.data.data.url){
          return dispatch('logout',{clearAssessmenttoken:true,navigate:false}).then(()=>{
            commit('setGlobalLoading',true, {root:true});
            document.location.href = response.data.data.url;
          });
        }
      });
    },
  },
  getters: {
    dataIsLoadedForCurrentAuthState(state, getters, rootState){
      if(!state.authToken || !state.assessmentid){
        return true;
      }
      return !!rootState.assessment.assessment && !!rootState.journey.journey && !!rootState.assets.list && !!rootState.textassets.list;
    },
    isLoggedIn(state){
      return !!state.authToken;
    }
  }
}
